import styled from "styled-components";
import { device } from "app/shared/styles/Breakpoints";

export const SectionExplorerSobreMi = styled.div`
  display: grid;
  gap: 10px;
  span {
    -ms-word-break: break-word;
    word-break: break-word;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    &.section_explorer-flex {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &.section_explorer-tree {
      display: grid;
      gap: 5px;
    }
  }

  ul {
    padding-left: 18px;
    display: grid;
    gap: 5px;

    li {
      display: flex;
      justify-content: flex-start;
    }
  }

  .item-list-span {
    cursor: pointer;
    a {
      color: var(--secondary-color-gray);
      text-decoration: none;
    }
    &:hover {
      color: var(--secondary-color-gray-hover-item);
      a {
        color: var(--secondary-color-gray-hover-item);
      }
    }
  }
`;

export const ContentSobreMi = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  grid-auto-rows: auto;
  > section {
    outline: var(--outline);
  }

  @media ${device.laptopS} {
    grid-template-columns: 1fr;
  }
`;

export const ContainerItemSectionPage = styled.div`
  background: transparent;
  padding-left: 30px;
  padding-right: 20px;
  border-radius: var(--border-radius-card);
  outline: var(--outline);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  transition: background-color 0.3s ease, border-color 0.3s ease,
    box-shadow 0.3s ease, outline 0.3s ease;
  width: 97%;
  border: 1px solid transparent;

  &.active-item-page {
    background: var(--primary-color-blue-active);
    border-color: rgba(77, 91, 206, 0.45);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35), 0 0 15px rgba(77, 91, 206, 0.08);
    outline: none;
  }

  .itemName {
    font-weight: 600;
    font-size: 1.05em;
  }
`;
